// For reference: https://www.cssscript.com/scrollspy-smooth-scroll-library-scrollspy-js/#google_vignette

class Scrollspy {
    constructor({
        menu,
        speed = 2000,
        easing = 'easeOutSine',
        enableMenuControl = false
    }) {
        this.$menu = menu;
        this.speed = speed;
        this.easing = easing;
        this.enableMenuControl = enableMenuControl;
    }

    scrollToY(targetY = 0) {
        let currentTime = 0;
        const scrollTargetY = targetY;
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        const time = Math.max(
            0.1,
            Math.min(Math.abs(scrollY - scrollTargetY) / this.speed, 0.8)
        );

        const easingEquations = {
            easeOutSine(pos) {
                return Math.sin(pos * (Math.PI / 2));
            },

            easeInOutSine(pos) {
                return -0.5 * (Math.cos(Math.PI * pos) - 1);
            },

            easeInOutQuint(pos) {
                if ((pos /= 0.5) < 1) return 0.5 * pos ** 5;
                return 0.5 * ((pos - 2) ** 5 + 2);
            }
        };

        const tick = () => {
            currentTime += 1 / 60;

            const p = currentTime / time;
            const t = easingEquations[this.easing](p);

            if (p < 1) {
                window.requestAnimationFrame(tick);
                window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
                return;
            }

            window.scrollTo(0, scrollTargetY);
        };

        tick();
    }

    menuControl() {
        const $links = this.$menu.querySelectorAll('a[href^="#"]');
        const scrollPos = window.scrollY || document.documentElement.scrollTop;

        $links.forEach((link) => {
            const $elem = document.querySelector(link.getAttribute('href'));

            return $elem.offsetTop <= scrollPos &&
                $elem.offsetTop + $elem.clientHeight > scrollPos
                ? link.classList.add('active')
                : link.classList.remove('active');
        })
    }

    animated() {
        const $links = this.$menu.querySelectorAll('a[href^="#"]');
        const self = this;

        function effectivePxValueFromCSSUnit(cssValue, target) {
            target = target || document.body;

            const supportedUnits = {
                // Absolute sizes
                'px': value => value,
                'cm': value => value * 38,
                'mm': value => value * 3.8,
                'q': value => value * 0.95,
                'in': value => value * 96,
                'pc': value => value * 16,
                'pt': value => value * 1.333333,

                // Relative sizes
                'rem': value => value * parseFloat(getComputedStyle(document.documentElement).fontSize),
                'em': value => value * parseFloat(getComputedStyle(target).fontSize),
                'vw': value => value / 100 * window.innerWidth,
                'vh': value => value / 100 * window.innerHeight,

                // Times
                'ms': value => value,
                's': value => value * 1000,

                // Angles
                'deg': value => value,
                'rad': value => value * (180 / Math.PI),
                'grad': value => value * (180 / 200),
                'turn': value => value * 360
            };

            // Match positive and negative numbers including decimals with following unit
            const pattern = new RegExp(`^([\-\+]?(?:\\d+(?:\\.\\d+)?))(${Object.keys(supportedUnits).join('|')})$`, 'i');

            // If is a match, return example: [ "-2.75rem", "-2.75", "rem" ]
            const matches = String.prototype.toString.apply(cssValue).trim().match(pattern);

            if (matches) {
                const value = Number(matches[1]);
                const unit = matches[2].toLocaleLowerCase();

                // Sanity check, make sure unit conversion function exists
                if (unit in supportedUnits) {
                    return supportedUnits[unit](value);
                }
            }

            return parseFloat(cssValue) || 0.0;
        }

        function control(e) {
            e.preventDefault();
            const $target = document.querySelector(this.hash);
            const targetPosition = $target.getBoundingClientRect().top + document.documentElement.scrollTop;
            let effectiveOffsetInPx = 0.0;
            const offset = this.getAttribute("data-offset");
            if (offset) {
                effectiveOffsetInPx = effectivePxValueFromCSSUnit(offset);
            }
            self.scrollToY(targetPosition + effectiveOffsetInPx);
        }

        for (const link of $links) {
            link.addEventListener('click', control);
        }
    }

    init() {
        this.animated();
        if (this.enableMenuControl) {
            document.addEventListener('scroll', () => this.menuControl());
        }
    }
}
